import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// @mui
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
// routes
import { RouterLink } from 'src/routes/components';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, href = "/", src ,state, sx, ...other }) => {

  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    navigate(href, { state });
  };


  // Only trust an absolute URL; a bare filename / empty / "noimg.png" falls back to the
  // default brand logo instead of rendering a broken image.
  const isUsableSrc =
    typeof src === 'string' && /^https?:\/\//.test(src) && !src.endsWith('noimg.png');

  const logo = (
    <Box
      component="img"
      onClick={!disabledLink ? handleClick : undefined} // attach click
      src={isUsableSrc ? src : "/assets/logo/mobileWashLogo.png"}
      sx={{
        width: sx?.width ?? 150,
        height: sx?.height ?? 90,
        objectFit: 'contain',   // Ensures image doesn't stretch/distort
        imageRendering: 'auto',  // Ensures sharp image rendering
        maxWidth: '100%',        // Ensures the image is responsive
        maxHeight: '100%',       // Prevents image from exceeding the container
        cursor: 'pointer',
        ...sx,
      }}
      {...other}
    />
  );

  if (disabledLink) {
    return logo;
  }

  return (
    <Link sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
